var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.data)?_c('div',{staticClass:"rich-text"},[_c('RichTextRenderer',{attrs:{"document":_vm.data,"nodeRenderers":_vm.rendererNodes(),"markRenderers":_vm.rendererMarks()}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }